import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Respuesta, KnowRespuesta } from '../../_models/shared/_index';
import { environment } from '../../../environments/environment';
import { Ficha } from '../../_models/comparador/ficha';
import { ComparadorCliente } from '../../_models/comparador/comparador-cliente';
import { SessionService } from '../session.service';
import { ErrorService } from '../error.service';
import { Observable, of } from 'rxjs';
import { TipoCompetencia } from '../../_enums/tipo-competencia';

@Injectable()
export class ComparadorService {
	public configuracion: any;

	// Rutas usando controller comparador

	private getMarcasUrl = environment.comparador + '/tmmv/getMarcas';
	private getMarcasByIdsUrl = environment.comparador + '/tmmv/getClasificacionesById';
	private getModelosUrl = environment.comparador + '/tmmv/getModelos';
	private getVersionesUrl = environment.comparador + '/tmmv/getVersiones';
	private getVersionesByIdsUrl = environment.comparador + '/tmmv/versiones';
	private countCompetidoresByNodoUrl =
		environment.comparador + '/Competidores/Count';
	// Otras
	private setCompetidoresUrl =
		environment.rest + '/ComparadorRest/setCompetidores';
	private getCompetidoresUrl =
		environment.rest + '/ComparadorRest/getCompetidores';
	private getFichaVersionUrl =
		environment.rest + '/api/version/{id_version}/ficha';
	private getFichaRsVersionUrl =
		environment.rest + '/api/version/{id_version}/ficha-rs';
	private getFichaUrl = environment.rest + '/api/mercado/ficha';
	private getFichaByVersionUrl =
		environment.rest + '/api/version/{id_version}/atributos-disponibles';
	private getReglasVentajasUrl =
		environment.rest + '/api/mercado/reglas-ventajas';
	private getConfiguracionByHashUrl =
		environment.rest + '/ComparadorRest/GetConfiguracionByHash';
	private getAtributosPorSegmentoByIdsVersionesUrl =
		environment.rest + '/ComparadorRest/GetAtributosPorSegmentoByIdsVersiones';
	private getHashComparadorUrl =
		environment.rest + '/ComparadorRest/GetHashComparador';
	private getComparadorClienteUrl =
		environment.rest + '/ComparadorRest/GetComparadorCliente';
	private getComparadoresUrl =
		environment.rest + '/ComparadorRest/GetComparadores';
	private actualizarComparadorUrl =
		environment.rest + '/ComparadorRest/ActualizarComparador';
	private getVersionesCompetenciaUrl =
		environment.rest + '/ComparadorRest/GetVersionesCompetencia';

	//rutas conducelo (Discontinuar)
	// private getVersionAtributoPorCodigoUrl =
	// 	environment.conducelo + '/api/Version/GetValorAtributo/';
	// private getModelosMarcaUrl = environment.conducelo + '/api/Busqueda/buscar';
	// private getVersionByIdRefUrl =
	// 	environment.conducelo + '/api/Version/GetByIdRef/';

	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};
	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(private http: HttpClient, private errorService: ErrorService) { }

	getFichaVersion(idVersion: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<any>(
				this.getFichaVersionUrl.replace('{id_version}', String(idVersion)),
				options
			)
			.pipe(
				catchError(this.errorService.handleError<Object>(`GET getFichaVersion`))
			);
	}

	getFichaRsVersion(idVersion: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<any>(
				this.getFichaRsVersionUrl.replace('{id_version}', String(idVersion)),
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Object>(`GET getFichaRsVersion`)
				)
			);
	}

	// getVersionAtributoPorCodigo(
	// 	idVersion: number,
	// 	codigoAtributo: string
	// ): Observable<any> {
	// 	var options = {
	// 		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
	// 	};
	// 	return this.http
	// 		.get<any>(
	// 			this.getVersionAtributoPorCodigoUrl +
	// 				idVersion +
	// 				'/' +
	// 				codigoAtributo +
	// 				'/',
	// 			options
	// 		)
	// 		.pipe(
	// 			catchError(
	// 				this.errorService.handleError<Object>(
	// 					`GET getVersionAtributoPorCodigo`
	// 				)
	// 			)
	// 		);
	// }

	getFicha(mercado: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getFichaUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			})
		);
	}

	getFichaByVersion(idVersion: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<any>(
				this.getFichaByVersionUrl.replace('{id_version}', String(idVersion)),
				options
			)
			.pipe(
				catchError(
					this.errorService.handleError<Object>(`GET getFichaByVersion`)
				)
			);
	}

	getReglasVentajas(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getReglasVentajasUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			})
		);
	}
	getMarcas(): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getMarcasUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`GET  getMarcas`)
			)
		);
	}

	// getMarcasByIds(idsClasificaciones: number[], idCliente: number): Observable<any> {
	// 	let options = { headers: this.headers, withCredentials: true };
	// 	return this.http
	// 		.post<any>(this.getMarcasByIdsUrl, { idsClasificaciones }, options)
	// 		.pipe(catchError(this.errorService.handleError<Object>(`POST getMarcasByIds`)));
	// }

	getMarcasByIds(idsClasificaciones: number[], idCliente: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<any>(this.getMarcasByIdsUrl, { idsClasificaciones, idCliente }, options)
			.pipe(
				catchError(this.errorService.handleError<Object>(`GET getModelos`))
			);
	}

	getModelos(idMarca: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<any>(this.getModelosUrl, { idMarca }, options)
			.pipe(
				catchError(this.errorService.handleError<Object>(`GET getModelos`))
			);
	}

	getVersiones(idModelo: number): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<any>(this.getVersionesUrl, { idModelo }, options)
			.pipe(
				catchError(this.errorService.handleError<Object>(`GET getVersiones`))
			);
	}

	getVersionesByIds(idsVersiones: Array<number>): Observable<any> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<any>(this.getVersionesByIdsUrl, { idsVersiones }, options)
			.pipe(
				catchError(
					this.errorService.handleError<Object>(`GET getVersionesByIds`)
				)
			);
	}

	// getModeloMarca(marca: string, mercado: number): Observable<any> {
	// 	var options = {
	// 		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
	// 	};
	// 	var payload = JSON.parse(
	// 		'{"idm":' +
	// 			mercado +
	// 			',"lreq":1530009537441,"order":"nombre","page":"1","limit":"1000","total":0,"totalVers":0,"q":"","term":["' +
	// 			marca +
	// 			'"]}'
	// 	);
	// 	return this.http
	// 		.post<any>(this.getModelosMarcaUrl, payload, options)
	// 		.pipe(
	// 			catchError(this.errorService.handleError<Object>(`GET getModeloMarca`))
	// 		);
	// }

	getConfiguracionByHash(hash: string): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getConfiguracionByHashUrl, { hash }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getConfiguracionByHash hash=${hash}`
					)
				)
			);
	}

	getCountCompetidores(
		idNodo: number,
		profundidad: number,
		idTipoCompetencia: number = TipoCompetencia.Comparador
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.countCompetidoresByNodoUrl,
				{ idNodo, profundidad, idTipoCompetencia },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post  getCountCompetidores idNodo=${idNodo} profundidad=${profundidad}`
					)
				)
			);
	}

	setCompetidores(
		idVersion: number,
		competidores: Array<number>,
		idTipoCompetencia: number
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.setCompetidoresUrl,
				{ idVersion, competidores, idTipoCompetencia },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> SetCompetidores`)
				)
			);
	}

	getCompetidores(idVersion: number, idTipoCompetencia: number = TipoCompetencia.Comparador): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getCompetidoresUrl, { idVersion, idTipoCompetencia }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST  getCompetidoresUrl idVersion=${idVersion}`
					)
				)
			);
	}

	getVersionesCompetencia(idVersion: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getVersionesCompetenciaUrl,
				{ idVersion },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST  getVersionesCompetencia idVersion=${idVersion}`
					)
				)
			);
	}

	getComparadores(): Observable<Respuesta> {
		return this.http.get<Respuesta>(this.getComparadoresUrl, this.options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`GET  getComparadores`)
			)
		);
	}

	// getVersionByIdRef(idVersionRef: number): Observable<any> {
	// 	return this.http
	// 		.get<Respuesta>(this.getVersionByIdRefUrl + idVersionRef, this.options)
	// 		.pipe(
	// 			tap((res) => {
	// 				this.errorService.CheckResponse(res);
	// 			}),
	// 			catchError(
	// 				this.errorService.handleError<Respuesta>(
	// 					`GET  getCompetidoresUrl idVersionRef=${idVersionRef}`
	// 				)
	// 			)
	// 		);
	// }

	setConfiguracion(configuracion: any) {
		this.configuracion = configuracion;
	}

	getConfiguracion() {
		return this.configuracion;
	}

	getEtiqueta(clave: string) {
		if (this.configuracion) {
			if (this.configuracion.etiquetas.hasOwnProperty(clave)) {
				return this.configuracion.etiquetas[clave];
			} else {
				return 'Error al obtener etiqueta traducida';
			}
		}
	}

	getAtributosPorSegmentoByIdsVersiones(
		idsVersiones: number[]
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getAtributosPorSegmentoByIdsVersionesUrl,
				{ idsVersiones },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getAtributosPorSegmentoByIdsVersiones hash=${idsVersiones}`
					)
				)
			);
	}

	getHashComparador(): Observable<any> {
		return this.http
			.get<Respuesta>(this.getHashComparadorUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`GET  getHashComparador`)
				)
			);
	}

	getComparadorCliente(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getComparadorClienteUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`GET getComparadorCliente`)
			)
		);
	}

	actualizarComparador(comparador: ComparadorCliente): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.actualizarComparadorUrl,
				{ comparador },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST  actualizarComparador`)
				)
			);
	}

	////////////////////////////////////////////////

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
